import Config, {ENV} from '@/config';
import axios from './axios';
import ticketApi from './ticket';

const commonApi = {
    uploadImage: (formData: any) => {
        return axios({
            // url: 'service/ticket/image_upload?action=uploadimage',
            // url: 'service/ticket/v2/image-upload?action=uploadimage',
            url: 'ticket/v1/file/image/upload?action=uploadimage',
            method: 'post',
            data: formData,
        }).then((res: any) => {
            if (res.data.url) {
                res.data.url = res.data.newUrl;
            }
            return res;
        });
    },
    uploadFile: (file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return axios({
            // url: 'service/ticket/v2/fileupload',
            url: 'ticket/v1/file/upload',
            method: 'post',
            data: formData,
        });
    },
    getRegions: () => {
        return axios({
            url: ENV === 'sandbox'
                ? 'region/get'
                : `${Config.CONSOLE_HOST}/api/region/get`,
            method: 'post',
        });
    },
};

export default {
    ...commonApi,
    ...ticketApi,
};

